import { Select } from 'antd'
import { NO_COMPARISON } from '../util/names'

export const EmptySelector = ({ value }: { value: string }) => {
  console
  return <Select value={value} options={[{ label: value, value: value }]} style={{ width: '100%' }} disabled={value === NO_COMPARISON} />
}
